import React from 'react';
import OlMapView from '../olmapview';
import $ from 'jquery';
import Livingplaces from '../../../models/livingplacecoll';
import Livingplaces_miscdata from '../../../models/miscStates';
import { Link } from 'react-router-dom';
import Searcher from '.././searcher'



export default class OlAddressMapView extends React.Component {
	constructor(props) {
		super(props);
		
	}
	componentDidMount() {

	  }
	
	  render() {
		  	var dts = window.datastore.lps.get(this.props.match.params.placeid).get('dailyTrips');
		  	var maxTripId = 0
		  	for (var i = 0; i < dts.length; i++) {
		  		var intId = parseInt(dts.models[i].get('id'));
		  		if (intId > maxTripId) {
		  			maxTripId = intId
		  		}
		  	}
		  	var nextTripId = (maxTripId + 1).toString() 
		    return (
		    		<div className="pagecontainer">
		    		<nav className="navbar navbar-default">
					  <div className="container-fluid header">
					    <div className="navbar-header">
					    <div className="row">
					    <div className="col-xs-12"><h4>Ziel auswählen</h4></div>
					    </div>
					  </div>
					  </div>
					</nav>
		    		<OlMapView basemapAtType='normal' id={ this.props.match.params.placeid } id_daily={ nextTripId } mapPurpose = {"selectDailyTargetAddress"} styleclass={"inframap"}>
		    		<AddressSearchBox id_daily={ nextTripId  } id={ this.props.match.params.placeid } history={this.props.history}/>
		    		</OlMapView>
		    		</div>
		    );
		  }
}

class AddressSearchBox extends React.Component {
	constructor(props) {
		super(props);
		var lpmodel = window.datastore.lps.get(this.props.id);
		this.state = {modelrdy: false}

			
		
	}
	changeaddrData (xystr, name) {
	    this.setState({
	      xy: xystr,
	      name: name,
	      modelrdy: true
	    });
	  }
	componentDidMount() {
		var id = this.props.id;
		var id_daily = this.props.id_daily;
		var comp = this;
		window.datastore.lps.get(id).get('dailyTrips').on("add", function(dailyTrip) {
			  if (dailyTrip.id === id_daily) {
				  var xy = dailyTrip.get('xy')
				  var name = dailyTrip.get('name')
				  comp.changeaddrData(xy, name)
			  }
			});
		
	}
	componentWillUnmount() {
//	     Ensure that we clean up any dangling references when the component is
//	     destroyed.
		var id = this.props.id;
	     window.datastore.lps.get(id).get('dailyTrips').off("add")
	}
	
	render() {
		var coordinates; 
		if (this.state && typeof this.state.xy !== 'undefined') {
			coordinates = 'Lon: ' + (Math.round(this.state.xy[0] * 10000) / 10000) + ', ' + 'Lat: ' + (Math.round(this.state.xy[1] * 10000) / 10000)
		} else {
			coordinates = '';
		}
		
		var addressname; 
		if (this.state && typeof this.state.xy !== 'undefined') {
			addressname = this.state.name
		} else {
			addressname = 'Bitte direkt auf die gewünschte Lage in der Karte klicken oder Standort über Suche ermitteln!';
		}

	    return (
	    		<div className="map-address-search panel panel-default">
	    		  <div className="panel-heading">Ziel</div>
	    		  <div className="panel-body">
	    		  <div className="addrcoords">{coordinates}</div>
	    		  <div>{addressname}</div>
	    		  <AcceptPlaceButton modelrdy={this.state.modelrdy} id={this.props.id} history = {this.props.history}/>
	    		  <hr />
	    		  <Searcher id={this.props.id} bbeventname={"searched_target"}/>
	    		  </div>
	    		</div>
	    )
	}
}

class AcceptPlaceButton extends React.Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {
	  }
	  render() {
		  var button;
		  if (this.props.modelrdy) {
			  button = <Link to={'/wohnstandorte/'+this.props.id+'/taeglichewege'}><button className="btn btn-primary placeacceptbutton">Übernehmen</button></Link>
		  }
		  else {
			  button = '';
		  }
		    return (
		    		<div>{button}</div>
		    );
		  }
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/dailytrips/DailyTripAddressMapview.js